import (/* webpackChunkName: "generalTable" */ '../../Styles/GeneralTable/generalTable.scss');

await import (/* webpackChunkName: "collapse" */ 'bootstrap/js/dist/collapse');

class GeneralTableComponent {
  constructor() {
    this.init();
  }

  init() {
    const self = this;
    const $elems = $(".am-general-table");
    $elems.each(function() {
      $(this).find(".am-general-table__item-collapser").on("click", self.clickEventHandler);
    });
  }

  clickEventHandler() {
    const elem = $(this);
    const id = elem.data("target");
    const target = $(id);

    if (target.hasClass("show")) {
      elem.removeClass("collapsed");
      target.collapse("hide");
    } else {
      elem.addClass("collapsed");
      target.collapse("show");
    }
  }
}

new GeneralTableComponent();
